import { useEffect, useState, useContext } from 'react';
import TextField from '@mui/material/TextField';
import Storage from '../../../session/storage';
import Autocomplete from '@mui/material/Autocomplete';
import CONSTANT from '../../../Constant/Constant';
import { Chip } from '@mui/material'
import { Close } from '@mui/icons-material';
import { DirectionContext } from '../../../context/DirectionProvider';
import { DropdownContext } from '../../../context/DropDownContext';
import { UiPicklistContext } from '../../../context/UiPicklistContext';
import profileData from '../../../config/ProfileDetailsData.json';
import prefferedLanguage from '../../../config/preffered_language.json';
const InputDetail = (props) => {
    const { uiDropdownValue } = useContext(UiPicklistContext);
    const [value, setValue] = useState(props.value || null)
    const [lengthFlag, setFlag] = useState();
    const [label] = useState(props.label);
    const [entity, setEntity] = useState(props.entity)
    const direction = useContext(DirectionContext);
    const { dropdownvalue } = useContext(DropdownContext);
    // const [required, setRequired] = useState();
    // const [dropdownKey, setDropdownKey] = useState(Date.now());
    // const [option, setOption] = useState([]);
    const sourceData = profileData

    /**
     * map name to key
     * @param {*} name name of attribute
     * @returns key name of attribute
    */
    const getOptionKey = (name, vendor) => {
        switch (name) {
            case 'Classification Code':
                if (vendor == "VNDR-VN") {
                    return 'Classification';
                }
                return 'Classification';
            case 'Sub Classification Code':
                return 'SubClassification';
            case 'Prefix':
                if (vendor == "VNDR-VN") {
                    return 'Title'
                }
                return 'Title';
            case 'Other Specialty':
                return 'Specialty';
            case 'Primary Specialty':
                if (vendor == "VNDR-VN") {
                    return 'Specialty'
                }
                return 'Specialty'
            case 'Specialty Type':
                return 'SpecialtyType';
            case 'Identifiers Type':
                return 'AltIDType';
            case 'Identifiers Sub Type':
                return 'AltIDSubtype';
            case 'State Province':
                return 'StateProvince';
            case 'Country':
                return 'Country';
            case 'Country Code':
                return 'Country';
            case 'Relation Type Code':
                return 'RelationshipType';
            case 'Preferred Language':
                return 'PreferredLanguage';
            default:
                return name;

        }
    }

    useEffect(() => {
        setEntity(props.entity)
    }, [props.entity])

    /**
     * Map name to ID
     * @param {*} name
     * @returns ID of atrribute
     */
    const getId = (name, vendor) => {
        switch (name) {
            case 'Classification Code':
                if (vendor == "VNDR-VN") {
                    return 'ClassificationCode';
                }
                return 'ClassificationCode';
            case 'Sub Classification Code':
                return 'SubClassificationCode';
            case 'Suffix Name':
                return 'SuffixName';
            case 'Middle Name':
                return 'MiddleName';
            case 'Primary Specialty':
                return 'PrimarySpecialty';
            case 'Other Specialty':
                return 'OtherSpecialty';
            case 'Identifiers Type':
                return 'Type';
            case 'Identifiers Sub Type':
                return 'SubType';
            case 'State Province':
                return 'StateProvince';
            case 'Prefix':
                if (vendor == "VNDR-VN") {
                    return 'Title';
                }
                return 'Prefix';
            case 'Relation Type Code':
                return 'RelationshipType ';
            case 'Preferred Language':
                return 'PreferredLanguage';
            default:
                return name;
        }
    }

    let options = (sourceData.OPEN_DATA_SOURCES.includes(props.source) ? CONSTANT.LOV_BOUNDED_OPTION_SPCIAL_CASE.includes(getId(label.trim())) : CONSTANT.LOV_BOUNDED_OPTION.includes(getId(label.trim()))) ? Storage.getLovBoundedList() : Storage.getPickList();
    options = CONSTANT.FORCED_OPTION.includes(label.trim()) ? { [entity]: { [label.trim()]: CONSTANT.FORCED_OPTION_VALUE[label.trim()] } } : options;
    // const [option, setOption] = useState(CONSTANT.STASTIC_ATTRIBUTE.includes(label.trim()) ? undefined : options[entity][getOptionKey(label?.trim(), props.vendor)]);  
    const [required, setRequired] = useState();

    let option;
    if (label.trim() === "Relation Type Code") {
        option = CONSTANT.STASTIC_ATTRIBUTE.includes(label.trim()) ? undefined : options[entity][getOptionKey(label?.trim(), props.vendor)][props?.source]
    } else if (getId(label.trim()) === 'PreferredLanguage') {
        if (props.source[0].value === 'VNDR-CGDM') {
            let country = props.country ? props.country[0]?.value : "default";
            option = prefferedLanguage.PreferredLanguages['VNDR-CGDM'][country] || prefferedLanguage.PreferredLanguages['VNDR-CGDM']['default'];
        } else {
            option = option = prefferedLanguage.PreferredLanguages['MNGD-AFF']
        }
    }
    else {
        option = CONSTANT.STASTIC_ATTRIBUTE.includes(label.trim()) ? undefined : options[entity][getOptionKey(label?.trim(), props.vendor)];

        // for state province to use LOV values
        if (props.isRelation) {
            if (props.source !== undefined && sourceData.OPEN_DATA_SOURCES.includes(props.source)) {
                option = CONSTANT.STASTIC_ATTRIBUTE_HCO_exclusion.includes(label.trim()) ? undefined : options?.HCO[getOptionKey(label?.trim())]
            } else {
                option = CONSTANT.STASTIC_ATTRIBUTE_HCO.includes(label.trim()) ? undefined : options?.HCO[getOptionKey(label?.trim())]
            }
        }
    }

    useEffect(() => {
        if (dropdownvalue === undefined || dropdownvalue === null || dropdownvalue.length === 0) return;
        options = CONSTANT.LOV_BOUNDED_OPTION.includes(getId(label.trim(), props.vendor)) ? dropdownvalue : uiDropdownValue['HCP'];
        options = CONSTANT.FORCED_OPTION.includes(label.trim()) ? { HCP: { [label.trim()]: CONSTANT.FORCED_OPTION_VALUE[label.trim()] } } : options;
        // setOption(CONSTANT.STASTIC_ATTRIBUTE.includes(label.trim()) ? undefined : options?.HCP[getOptionKey(label?.trim(), props.vendor)]);
        if (label.trim() === "Relation Type Code") {
            option = CONSTANT.STASTIC_ATTRIBUTE.includes(label.trim()) ? undefined : options[entity][getOptionKey(label?.trim(), props.vendor)][props?.source]
        } else if (getId(label.trim()) === 'PreferredLanguage') {
            if (props.source[0].value === 'VNDR-CGDM') {
                let country = props.country ? props.country[0]?.value : "default";
                option = prefferedLanguage.PreferredLanguages['VNDR-CGDM'][country] || prefferedLanguage.PreferredLanguages['VNDR-CGDM']['default'];
            } else {
                option = option = prefferedLanguage.PreferredLanguages['MNGD-AFF']
            }

        }
        else {
            option = CONSTANT.STASTIC_ATTRIBUTE.includes(label.trim()) ? undefined : options?.HCP[getOptionKey(label?.trim(), props.vendor)];
            // option = CONSTANT.STASTIC_ATTRIBUTE.includes(label.trim()) ? undefined : options[entity][getOptionKey(label?.trim(), props.vendor)];
            // for state province to use LOV values
            if (props.isRelation) {
                if (props.source !== undefined && sourceData.OPEN_DATA_SOURCES.includes(props.source)) {
                    option = CONSTANT.STASTIC_ATTRIBUTE_HCO_exclusion.includes(label.trim()) ? undefined : options?.HCO[getOptionKey(label?.trim())]
                } else {
                    option = CONSTANT.STASTIC_ATTRIBUTE_HCO.includes(label.trim()) ? undefined : options?.HCO[getOptionKey(label?.trim())]
                }
            }
        }
    }, [dropdownvalue])


    /**
     * Pass value to parent
     * @param {*} event
     */
    const passToParent = async (event) => {
        setFlag(event.target.value === null || (event.target.value !== null && event.target.value.length === 0));
        await setValue(event.target.value)
        props.updatedValue({ value: event.target.value === null ? '' : event.target.value }, required && (event.target.value === null || (event.target.value !== null && event.target.value.length === 0)))
    }

    /**
     * Handel Input Change
     * @param {*} event : event
     * @param {*} passTo : parent flag
     * @param {*} reqFlag : validation flag
     */
    const handelInput = (event, passTo, reqFlag) => {

        setFlag(event.target.value === null || (event.target.value !== null && event.target.value.length === 0))
        setValue(event.target.value)

        if (passTo) {
            passToParent(event)
        }
    }


    useEffect(() => {
        let flag = (value === null) || (value !== null && value !== undefined && value.length === 0);
        flag = (props.error && flag)
        setFlag(flag);
        setRequired(props.newHCP !== undefined ? CONSTANT.REQUIRED_HCP.includes(label.trim()) : !CONSTANT.OPTIONAL.includes(getId(label.trim())))

        if (props.clear && option === undefined) {
            setValue('')
        } else if (props.clear && option !== undefined) {
            setValue(null)
        }
    }, [props.clear, option, props.error, value, label, props.newHCP])

    return (
        <>
            {

                props.date === false && option !== undefined && !['Preferred Language', 'Active Flag', 'Country', 'Rank', 'State Province'].includes(label.trim()) &&
                <Autocomplete
                    // value={(label.trim() === 'Other Specialty' && value === null) ? [] : value}
                    disableClearable={CONSTANT.OPTIONAL.includes(getId(label.trim()))}
                    // value={(label.trim() === 'Other Specialty' && value === null) ? [] :
                    //     props.lookupRawValue && value && value?.split(' | ').length === 1 ? option?.flatMap(group => group.options ? group.options : group).find(d => d.split(' | ').length > 0 && d.split(' | ')[d.split(' | ').length - 1].split('//')[0].trim() === props.lookupRawValue) : value
                    // }
                    value={
                        (label.trim() === 'Other Specialty' && value === null)
                            ? []
                            : props.lookupRawValue && value && value?.split(' | ').length === 1
                                ? option
                                    ?.flatMap(group => group.options ? group.options : group)
                                    .find(d => {
                                        const parts = d.split(' | ').map(p => p.trim());
                                        const labelValue = parts[0];
                                        const codeValue = parts[parts.length - 1];

                                        return (
                                            codeValue === props.lookupRawValue ||
                                            labelValue === props.lookupRawValue
                                        );
                                    })
                                ?? option
                                    ?.flatMap(group => group.options ? group.options : group)
                                    .find(d => d.split('//')[0].split(' | ')[0].trim() === value)
                                ?? value
                                : value
                    }
                    key={label}
                    onChange={(event, value) =>
                        handelInput({
                            target: {
                                value: label.trim() === 'Other Specialty'
                                    ? value.length > 0
                                        ? value.map(res => res.split('//')[0])
                                        : value
                                    : value?.split('//')[0].length > 0
                                        ? value.split('//')[0]
                                        : value
                            }
                        }, true)}
                    options={option.flatMap(group => group.options ? group.options : group)}
                    getOptionLabel={(option) => option?.split('//')[0]}
                    getOptionDisabled={(option) => props.limitFlag != undefined && props.limitFlag && value != null && value.length >= props.count &&
                        !value.includes(option)}
                    groupBy={(option) => { return option?.includes('//UnClassified') ? 'Unclassified' : `${entity} - ${label} ` }}
                    isOptionEqualToValue={(option, value) => option?.split('//')[0] === value}
                    id={label}
                    name={label}
                    renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => (
                            <Chip
                                sx={{ direction, padding: '3px' }}
                                deleteIcon={<Close sx={{ margin: '0 !important' }} />}
                                label={<span className='_wg-exclude'>{option}</span>}
                                {...getTagProps({ index })}
                            />
                        ))
                    }
                    multiple={label.trim() === 'Other Specialty'}
                    renderInput={(params) =>
                        <TextField {...params} error={(lengthFlag) && required}
                            variant="standard"
                            id="varantOptionTxT"
                            helperText={((lengthFlag) && required) ? "Please Select One Option" : " "} />}
                />

            }
            {

                props.date === false && option !== undefined && ['Preferred Language'].includes(label.trim()) &&
                <Autocomplete
                    disableClearable={CONSTANT.OPTIONAL.includes(getId(label.trim()))}
                    value={
                        typeof value === 'string'
                            ? option
                                ?.flatMap(g => g.options ?? g)
                                ?.find(
                                    opt =>
                                        opt?.split('//')[0]
                                            ?.split(' | ')
                                            ?.pop()
                                            ?.trim() === value
                                ) ?? value
                            : null
                    }

                    options={option?.flatMap(g => g.options ?? g) ?? []}

                    getOptionLabel={(option) =>
                        typeof option === 'string'
                            ? option.split('//')[0]
                            : ''
                    }

                    isOptionEqualToValue={(option, value) =>
                        option?.split('//')[0] === value?.split('//')[0]
                    }

                    onChange={(event, selected) => {
                        const finalValue =
                            typeof selected === 'string'
                                ? selected.split('//')[0].split(' | ').pop().trim()
                                : null;

                        handelInput(
                            { target: { value: finalValue } },
                            true
                        );
                    }}

                    groupBy={(optionValue) =>
                        optionValue?.includes('//UnClassified')
                            ? 'Unclassified'
                            : `${entity} - ${label}`
                    }

                    id={label}
                    name={label}

                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="standard"
                            error={lengthFlag && required}
                            helperText={
                                lengthFlag && required
                                    ? 'Please Select One Option'
                                    : ' '
                            }
                        />
                    )}
                />

            }
            {
                props.date === false && option !== undefined && ['Active Flag', 'Country', 'Rank', 'State Province'].includes(label.trim()) &&
                <Autocomplete
                    disableClearable={CONSTANT.OPTIONAL.includes(getId(label.trim()))}
                    value={(label.trim() === 'Other Specialty' && value === null) ? [] : value?.split(' | ').length ? value?.split(' | ')[value.split(' | ').length - 1] : value}
                    key={label}
                    onChange={(event, value) => handelInput({ target: { value: value?.split(' | ')[value.split(' | ')?.length - 1] } }, true)}
                    options={option.sort((a, b) => (a > b) ? 1 : -1)}
                    getOptionLabel={(option) => option?.split(' | ')[0]}
                    isOptionEqualToValue={(option, value) => option?.split(' | ')[option.split(' | ').length - 1] === value}
                    id={label}
                    name={label}
                    renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => (
                            <Chip
                                sx={{ direction, padding: '3px' }}
                                deleteIcon={<Close sx={{ margin: '0 !important' }} />}
                                label={<span className='_wg-exclude'>{option?.split(' | ')[0]}</span>}
                                {...getTagProps({ index })}
                            />
                        ))
                    }
                    multiple={label.trim() === 'Other Specialty'}
                    renderInput={(params) =>
                        <TextField {...params} error={(lengthFlag) && required}
                            variant="standard"
                            id="varantOptionTxT"
                            helperText={((lengthFlag) && required) ? "Please Select One Option" : " "} />}
                />
            }

            {
                props.date === true && props.type !== 'number' && option === undefined &&
                <TextField
                    value={value || ''}
                    id={label}
                    variant="standard"
                    name={label}

                    onChange={handelInput}
                    error={((lengthFlag) && required)}
                    helperText={((lengthFlag) && required) ? <span className='input-text'>Please Enter Valid Input</span> : " "}
                    onBlur={passToParent}
                    className="w-100 input-text"
                    type="date"

                    inputProps={{ max: "9999-12-31" }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            }
            {
                props.date === false && option === undefined &&
                < TextField
                    type={props.type}
                    key={label}
                    variant="standard"
                    error={((lengthFlag) && required)}
                    helperText={((lengthFlag) && required) ? <span id="input-text">Please Enter Valid Input</span> : " "}
                    value={(value || '')}
                    onChange={handelInput}
                    onBlur={passToParent}
                    id={label}
                    name={label}
                    color="primary" className="w-100 input-text" />
            }
        </>
    )

}

export default InputDetail;
